import {
  ModalHandler,
} from '@app-velocity/ui';

import { NotificationsModalContent } from './components/NotificationsModalContent';

export const NotificationsModal = () => {
  return (
    <ModalHandler channel="users" id="notifications">
      <NotificationsModalContent />
    </ModalHandler>
  );
};
